import "./font.css";
import { isExternal } from "./shared/sharedService.js";

const CONFIG_PROMISE_KEY = "__CONFIG_PROMISE__";

const loadConfigOnce = () => {
  if (window.__CONFIG__) return Promise.resolve(window.__CONFIG__);
  if (window[CONFIG_PROMISE_KEY]) return window[CONFIG_PROMISE_KEY];

  const url = isExternal()
    ? "/cli/assets/config/config.json"
    : "/assets/config/config.json";

  window[CONFIG_PROMISE_KEY] = fetch(url)
    .then((res) => res.json())
    .then((config) => {
      if (isExternal()) {
        config = {
          ...config,
          REACT_APP_PRICING_REMOTE_URL:
            config.REACT_APP_EXTERNAL_PRICING_REMOTE_URL,
          REACT_APP_LTOVFUIEMP_REMOTE_URL:
            config.REACT_APP_EXTERNAL_LTOVFUIEMP_REMOTE_URL,
          REACT_APP_DOCGEN_REMOTE_URL:
            config.REACT_APP_EXTERNAL_DOCGEN_REMOTE_URL,
          REACT_APP_REVIEW_REMOTE_URL:
            config.REACT_APP_EXTERNAL_REVIEW_REMOTE_URL,
          REACT_APP_REPORTING_REMOTE_URL:
            config.REACT_APP_EXTERNAL_REPORTING_REMOTE_URL,
          REACT_APP_PARTNER_PROGRAM_REMOTE_URL:
            config.REACT_APP_EXTERNAL_PARTNER_PROGRAM_REMOTE_URL ||
            config.REACT_APP_PARTNER_PROGRAM_REMOTE_URL,
        };
      }
      window.__CONFIG__ = config;
      return config;
    })
    .finally(() => {
      window[CONFIG_PROMISE_KEY] = null;
    });

  return window[CONFIG_PROMISE_KEY];
};

loadConfigOnce().then(() => {
  import("./bootstrap.js");
});
